export const app_config = {
  toast_config: {
    position: "top-right",
  },
};
